import { TFunction } from 'i18next';
import { AIActionKind, AIPromptActionTemplate } from 'models/copilot/actions/aiActionTemplate';

// The library's ready-made question about the selected document (document_summary on the Link entity ref).
// No edit verbs in the prompt: the turn is a read, not a document edit.
export const librarySummarizeDocumentTemplate: AIPromptActionTemplate = {
  id: 'library.summarizeDocument',
  kind: AIActionKind.Prompt,
  getLabel(t: TFunction<string[]>) {
    return t('copilot:Actions.Scenes.Library.SummarizeDocument.Label');
  },
  getPrompt(t: TFunction<string[]>) {
    return t('copilot:Actions.Scenes.Library.SummarizeDocument.Prompt');
  },
};
